<template>
  <div
    id="statistic_app_page"
    class="card"
  >
    <b-card-header>
      <ps-filters
        v-model="filterValues"
        :filter-settings="filterSettings"
        :show-export="$hasPermission('export_survey_stats')"
        @search="search"
        @exportToCSV="exportToCSV"
      />
    </b-card-header>
    <div class="table-responsive mb-0">
      <table
        role="table"
        class="table b-table table-striped table-hover"
      >
        <thead
          role="rowgroup"
          class=""
        >
          <tr
            role="row"
            class=""
          >
            <th
              v-if="groupBy === 'app'"
              role="columnheader"
              aria-colindex="1"
            >
              {{ $t('logs.app') }}
            </th>
            <th
              v-if="groupBy === 'date'"
              role="columnheader"
              aria-colindex="1"
              :aria-sort="arialSort('date')"
              @click="sortCol('date')"
            >
              {{ $t('revenuestatistics.date') }}
            </th>
            <th
              v-if="groupBy === 'country'"
              role="columnheader"
              aria-colindex="1"
              :aria-sort="arialSort('country_code')"
              @click="sortCol('country_code')"
            >
              {{ $t('dashboard.country') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('unique_users')"
              @click="sortCol('unique_users')"
            >
              {{ $t('statistics.uniqueUsers') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('clicks')"
              @click="sortCol('clicks')"
            >
              {{ $t('statistics.clicks') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('completes')"
              @click="sortCol('completes')"
            >
              {{ $t('statistics.completes') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('completes_revenue')"
              @click="sortCol('completes_revenue')"
            >
              {{ $t('statistics.completesRevenue') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('screenout_revenue')"
              @click="sortCol('screenout_revenue')"
            >
              {{ $t('statistics.screenoutRevenue') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('total_revenue')"
              @click="sortCol('total_revenue')"
            >
              {{ $t('revenuestatistics.totalRevenue') }}
            </th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          <template v-for="(rowTr, indextr) in items">
            <tr
              :key="indextr"
              :class="rowTr.class"
            >
              <td v-if="groupBy === 'app'">
                <app-link :app="rowTr" />
              </td>
              <td v-if="groupBy === 'date'">
                {{ rowTr.date | dotDateTimeShort }}
              </td>
              <td v-if="groupBy === 'country'">
                {{ rowTr.country_name }}
              </td>
              <td>
                {{ rowTr.unique_users | formatCount }}
              </td>
              <td>
                {{ rowTr.clicks_count | formatCount }}
              </td>
              <td>
                {{ rowTr.completes_count | formatCount }}
              </td>
              <td class="text-success">
                {{ rowTr.completes_revenue | formatCurrency }}
              </td>
              <td class="text-success">
                {{ rowTr.screenout_revenue | formatCurrency }}
              </td>
              <td class="text-success">
                {{ rowTr.total_revenue | formatCurrency }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <b-card-footer>
      <b-row>
        <b-col
          v-show="items.length > 0"
          cols="12"
        >
          <pagination-and-table-info
            :data="paginationData"
            @change="handleChangePage($event)"
          />
        </b-col>
        <b-col
          v-show="items.length === 0"
          cols="12"
          style="font-weight: 500; text-align: center"
        >
          {{ $t('apps.noData') }}
        </b-col>
      </b-row>
    </b-card-footer>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

import PaginationAndTableInfo from '@ps_main/custom-components/PaginationAndTableInfo.vue'
import PsFilters from '@/main/custom-components/PsFilters.vue'
import AppLink from '@ps_main/custom-components/AppLink.vue'

export default {
  components: {
    AppLink,
    PsFilters,
    PaginationAndTableInfo,
  },
  data() {
    const $this = this

    return {
      items: [],
      params: {
        page: 1,
        order_by: 'date',
        item_per_page: 500,
        order_direction: 'desc',
        init_filter: 0,
      },
      filterValues: {},
      filterSettings: {
        date_range: {
          type: 'daterange',
          get label() { return i18n.t('logs.fromTo') },
          class: 'mr-2 mb-0',
          style: '',
          data: [],
          defaultValue: {
            from_date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
            to_date: new Date(),
          },
          'label-cols': 2,
        },
        app: {
          type: 'select',
          get label() { return i18n.t('apps.appName') },
          class: 'mr-2 mb-0',
          style: 'width: 320px;',
          data: [],
          defaultData: { value: null, get text() { return i18n.t('logs.allApps') } },
          defaultValue: null,
          'label-cols': 4,
        },
        country: {
          type: 'select',
          get label() { return i18n.t('revenuestatistics.country') },
          class: 'mr-2 mb-0',
          style: 'width: 320px;',
          data: [],
          defaultData: { value: null, get text() { return i18n.t('revenuestatistics.allCountries') } },
          defaultValue: null,
          'label-cols': 3,
        },
        group_by: {
          type: 'radio',
          get label() { return i18n.t('revenuestatistics.groupBy') },
          class: 'mr-2',
          'label-cols': 2,
          'content-cols': 10,
          style: 'width: 400px;',
          defaultValue: 'app',
          data: [
            {
              value: 'app',
              get text() { return i18n.t('logs.app') },
            },
            {
              value: 'country',
              get text() { return i18n.t('dashboard.country') },
            },
            {
              value: 'date',
              get text() { return i18n.t('revenuestatistics.day') },
            },
          ],
          change(value) {
            $this.selectedGroupBy = value
          },
          refresh_uuid: null,
        },
      },
      pageTotal: 0,
      totalItems: 0,
      responseData: null,
      selectedGroupBy: 'app',
      groupBy: 'app',
    }
  },
  computed: {
    paginationData() {
      return this.laravelPaginationPages(this.responseData)
    },
  },
  methods: {
    handleChangePage(page) {
      this.params.page = page
      this.search()
    },
    sortCol(fieldName) {
      if (this.params.order_by === fieldName) {
        this.params.order_direction = this.params.order_direction === 'asc' ? 'desc' : 'asc'
      } else {
        this.params.order_by = fieldName
        this.params.order_direction = 'asc'
      }
      this.search()
    },
    arialSort(sortFieldName) {
      if (this.params.order_by === sortFieldName) {
        return this.params.order_direction === 'asc'
          ? 'ascending'
          : 'descending'
      }
      return 'none'
    },
    search() {
      // this.groupBy = this.params.filters.group_by
      this.showLoading()
      this.$http
        .get('/api/statistics/survey', {
          params: {
            ...this.params,
            ...this.filterValues,
          },
        })
        .then(response => {
          this.groupBy = this.selectedGroupBy
          const responseData = response.data
          this.items = responseData.data
          this.responseData = responseData
          this.initiateFilters(responseData)
        })
        .catch(errors => {
          this.items = []
          this.responseData = null
          this.alertApiError(errors, i18n.t('surveystatistics.surveyStatisticsRequestFailed'))
        })
        .finally(() => {
          this.hideLoading()
        })
    },
    initiateFilters(responseData) {
      if (
        this.params.init_filter === 0
          && typeof responseData.filter_data !== 'undefined'
      ) {
        Object.keys(responseData.filter_data).forEach(property => {
          if (typeof this.filterSettings[property] === 'object') {
            if (this.filterSettings[property].defaultData !== undefined) {
              this.filterSettings[property].data = [
                ...[this.filterSettings[property].defaultData],
                ...responseData.filter_data[property],
              ]
            } else {
              this.filterSettings[property].data = responseData.filter_data[property]
            }
          }
        })

        this.params.init_filter = 1
      }
    },
    exportToCSV() {
      const exportLocale = i18n.locale
      this.isBusy = true
      this.showLoading()
      this.$http
        .get('/api/statistics/survey/export', {
          params: {
            ...this.params,
            ...this.filterValues,
            locale: exportLocale,
            only_file_name: true,
          },
        })
        .then(response => {
          const filename = response.data

          return this.$http
            .get('/api/statistics/survey/export', {
              params: {
                ...this.params,
                ...this.filterValues,
                locale: exportLocale,
              },
              responseType: 'blob',
            })
            .then(responseExport => {
              const url = window.URL.createObjectURL(new Blob([responseExport.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', filename)
              document.body.appendChild(link)
              link.click()
            })
            .catch(errors => {
              this.alertApiError(errors, i18n.t('surveystatistics.surveyStatisticsExportFailed'))
            })
        })
        .catch(errors => {
          this.alertApiError(errors, i18n.t('surveystatistics.surveyStatisticsExportFailed'))
        })
        .finally(() => {
          this.hideLoading()
          this.isBusy = false
        })
    },
  },
}
</script>
